import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import {
  parseAppLanguage,
  setAppLanguage,
} from "src/shared/util/src/language/dico";
import { SHOWCASE_LANGUAGE_KEY } from "src/shared/util/src/language/showcase";

if (import.meta.env.DEV) {
  try {
    const savedLanguage = parseAppLanguage(
      localStorage.getItem(SHOWCASE_LANGUAGE_KEY),
    );
    if (savedLanguage) setAppLanguage(savedLanguage);
  } catch {
    // Use browser language when storage is unavailable.
  }
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
